module.exports = __webpack_public_path__ + "img/patterns.38da1b58.png";